import { makeAutoObservable } from 'mobx';
import { logger } from '@/infrastructure/logger';
import { customEventService, IEventInfo } from '@/service/custom-event';

export class CustomEventStore {
  events: IEventInfo[] = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async getEvents() {
    try {
      this.events = await customEventService.listEvents({});
    } catch (e) {
      logger.error('getEvents err:', e);
    }
  }
}
